// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require("jquery")
import('uswds')
import('uswds/dist/scss/uswds.scss')
require('jszip')
require('datatables.net-bs4')
require('datatables.net-fixedcolumns-bs4')
require('datatables.net-responsive-bs4')
require('datatables.net-select-bs4')
require("chartkick")
import("chart.js")

require("bootstrap")
import "../stylesheets/application"
import "../stylesheets/custom.scss"
import 'bootstrap-icons/font/bootstrap-icons.css'

require("flatpickr")
import("flatpickr/dist/themes/dark.css")

import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css"
import "datatables.net-select-bs4/css/select.bootstrap4.css"
import 'datatables.net-buttons/js/buttons.html5'

document.addEventListener("turbolinks:load", () => {
  flatpickr("[data-behavior='flatpickr']", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    shorthandCurrentMonth: true,
  });

  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('.toast').toast({
    autohide: false
  });
  $('#toast').toast('show')
  //This is an override to get TurboLinks to play nice the USWDS accordion JS.
  $('#gov-banner').hide();
  $('.usa-accordion').click(function () {
    $("#gov-banner").toggle()
  });

  $('.datatable').DataTable({
    "lengthMenu": [
      [15, 25, 50, 75, 100, -1],
      [15, 25, 50, 75, 100, "All"]
    ],
    "oLanguage": {
      "sSearch": "Filter"
    },
    buttons: [
      {
        extend: 'csv',
        text: "Export to CSV"
      },
      'copy'
    ],
    dom: 'B<"clear">lfrtip',
    fixedHeader: true,
    responsive: true,
    "sDom": '<"H"lr>t<"F"ip>'
  })

  $('.dt-buttons').addClass('mt-3')
  $('.buttons-html5').addClass('btn btn-sm btn-info')
  $('.dataTables_info').addClass('mt-3')
});

// // Uncomment to copy all static images under ../images to the output folder and reference
// // them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// // or the `imagePath` JavaScript helper below.
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")